$W.on('load', function(){
		let sliderSwiper = new Swiper('.js-slider', {
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		slidesPerView: 1,
		spaceBetween: 0,
		loop: true,
		speed: 1200,
		autoplay: {
			delay: 5000,
		},
		autoHeight: true,
		simulateTouch: true,
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
		breakpoints: {
			992: {
				autoHeight: false,
			}
		}
	});
})
$(function () {

	let partnersSwiper = new Swiper('.js-partners-slider', {
		slidesPerView: 'auto',
		spaceBetween: 35,
		loop: false,
		speed: 1200,
		simulateTouch: true,
		watchOverflow: false,
		navigation: {
			nextEl: '.js-partners-slider__next',
			prevEl: '.js-partners-slider__prev',
		},
		breakpoints: {
			1100: {
				slidesPerView: 5,
				spaceBetween: 35,
			},
			600: {
				slidesPerView: 4,
				spaceBetween: 35,
			},
			320: {
				slidesPerView: 2,
				spaceBetween: 10,
			}
		}
	});

	let clientsSwiper = new Swiper('.js-clients-slider', {
		slidesPerView: 2,
		spaceBetween: 0,
		loop: false,
		speed: 1200,
		simulateTouch: true,
		watchOverflow: false,
		navigation: {
			nextEl: '.js-partners-slider__next',
			prevEl: '.js-partners-slider__prev',
		},
		breakpoints: {
			1100: {
				slidesPerView: 5,
			},
			600: {
				slidesPerView: 4,
			},
			480: {
				slidesPerView: 3,
			}
		}
	});

	let newsSwiper = new Swiper('.js-news-slider', {
		slidesPerView: 'auto',
		spaceBetween: 0,
		loop: false,
		speed: 1200,
		simulateTouch: true,
		watchOverflow: false,
		navigation: {
			nextEl: '.js-news-slider__next',
			prevEl: '.js-news-slider__prev',
		},
	});

	//dynamic url for iframe

	let $gallerySlider = $('.js-gallery-slider');


	function iframeUrl(){
		$gallerySlider.each(function () {
			let iFrame = $(this).find('.swiper-slide-active video');

			if (iFrame.length) {
				let frameSrc = iFrame.data('src');
		
				iFrame.attr('src', frameSrc);
			}
		})
	}
	window.iframeUrl = iframeUrl;

	function iframeUrlAutoplay(){
		$gallerySlider.each(function () {
			let iFrame = $(this).find('.swiper-slide-active video');

			if (iFrame.length) {
				let frameSrc = iFrame.data('src');
				$(this).find('.swiper-slide video').attr('src', '');
				iFrame.attr('src', frameSrc);
				iFrame.trigger('play');
			}
		})
	}


	multipleSwiperThumb();

	window.multipleSwiperThumb = multipleSwiperThumb;


	function multipleSwiperThumb(){

		let thumb = [];
		let historyTop = [];
		let todayMainSliderSelector = '.js-gallery-slider',
		interleaveOffset = 0.5;

		$('.js-gallery-slider-thumbs').each(function (i, obj) {
			thumb[i] = new Swiper( obj, {
				slidesPerView: 2,
				spaceBetween: 5,
				loop: false,
				watchSlidesVisibility: true,
				watchSlidesProgress: true,
				breakpoints: {
					480: {
						slidesPerView: 3,
						spaceBetween: 10
					},
					992: {
						slidesPerView: 5,
						spaceBetween: 10
					}
				}
			});

		});


		$('.js-gallery-slider').each(function (i, obj) {
			historyTop[i] = new Swiper(obj, {
				effect: 'fade',
				loop: false,
				fadeEffect: {
					crossFade: true
				},
				slidesPerView: 1,
				spaceBetween: 0,
				speed: 1000,
				thumbs: {
					swiper: thumb[i]
				},
				autoHeight: true,
				on: {
					init: function(){
						iframeUrl();
						if ( $('.js-gallery-slider-ajax').length ) {
							let iFrameAjax = $('.js-gallery-slider-ajax').find('.swiper-slide-active video');
							let frameSrcAjax = iFrameAjax.data('src');
							iFrameAjax.attr('src', frameSrcAjax);
						}
					},
					slideChangeTransitionEnd: function () {
						this.updateAutoHeight(300);
						iframeUrlAutoplay();
						if ( $('.js-gallery-slider-ajax').length ) {
							let iFrameAjax = $('.js-gallery-slider-ajax').find('.swiper-slide-active video');
							let frameSrcAjax = iFrameAjax.data('src');
							$('.swiper-slide video').attr('src', '');
							$('.js-gallery-slider-ajax').find('.swiper-slide video').attr('src', '');
							iFrameAjax.attr('src', frameSrcAjax);
							iFrameAjax.trigger('play');
						}
					},
				}
			});

			const $root = $(this).closest('.js-wrapper-slider');
			$root.find('.js-gallery-slider-thumbs__prev').on('click', () => historyTop[i].slidePrev());
			$root.find('.js-gallery-slider-thumbs__next').on('click', () => historyTop[i].slideNext());
		});
	}


	let $slider = $('.js-slider-count');

	if ($slider.length) {
		$slider.each(function(){
			let $this = $(this);
			let count = $this.data('slide');
			let slide = $this.find('.swiper-slide').length

			if ( slide <= count) {
				$this.find('.slider-arrow').hide()
			}
		})
	}

	let objectSwiper = new Swiper('.js-object-slider', {
		slidesPerView: 1,
		spaceBetween: 0,
		loop: true,
		speed: 700,
		navigation: {
			nextEl: '.js-object-slider__next',
			prevEl: '.js-object-slider__prev',
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
		}
	});

	function sliderImages(){

		// Parallax slider
		let gallerySelector = '.js-slider-images';
		let	interleaveOffsetGallery = 0.5;

		let galleryOptions = {
		  loop: true,
		  speed: 1500,
		  autoHeight: true,
		  initialSlide: 0,
		  spaceBetween: 0,
		  autoplay:{
			delay: 4000
		  },
		  grabCursor: false,
		  simulateTouch: true,
		  watchSlidesProgress: true,
		  navigation: {
			nextEl: '.js-slider-images__next',
			prevEl: '.js-slider-images__prev',
		  },
		  pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true,
			},
		  breakpoints: {
			961: {
			  simulateTouch: true
			}
		  },
		  on: {
			progress: function(){
			  let swiper = this;
			  for (let i = 0; i < swiper.slides.length; i++) {
				let slideProgress = swiper.slides[i].progress,
					innerOffset = swiper.width * interleaveOffsetGallery,
					innerTranslate = slideProgress * innerOffset;
					swiper.slides[i].querySelector(".js-slider-images__slide").style.transform = "translate3d(" + innerTranslate + "px, 0, 0)";
			  }
			},
			touchStart: function() {
			  let swiper = this;
			  for (let i = 0; i < swiper.slides.length; i++) {
				swiper.slides[i].style.transition = "";
			  }
			},
			setTransition: function(speed) {
			  let swiper = this;
			  for (let i = 0; i < swiper.slides.length; i++) {
				swiper.slides[i].style.transition = speed + "ms";
				swiper.slides[i].querySelector(".js-slider-images__slide").style.transition =
				  speed + "ms";
			  }
			}
		  }
		};
		let gallerySlider = new Swiper(gallerySelector, galleryOptions);
	}

	sliderImages();

	window.sliderImages = sliderImages;


	let sertSwiper = new Swiper('.js-sert-slider', {
		slidesPerView: 1,
		spaceBetween: 6,
		loop: false,
		speed: 1200,
		simulateTouch: true,
		navigation: {
			nextEl: '.js-sert-slider__next',
			prevEl: '.js-sert-slider__prev',
		},
		breakpoints: {
			769: {
				slidesPerView: 2,
			},
		}
	});



});